'use strict';

export default (content, map) => {
    // Parse as HTML since HTML fragments cannot be wrapped into CDATA section because of SFCC comments.
    const doc = new window.DOMParser().parseFromString(content.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, ''), 'text/html');
    let result = {};
    map.forEach(function (processor) {
        if (processor.hasOwnProperty('byTagName')) {
            const elements = doc.getElementsByTagName(processor.byTagName);
            Array.from(elements).forEach((element) => {
                processor.callback(element, result);
            });
        }
    });
    return result;
};
